import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme';
import { AppRoutes } from './routes';
import SnackbarManager from './components/ui/SnackbarManager';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppRoutes />
      <SnackbarManager />
    </ThemeProvider>
  );
}

export default App; 